import React from "react"
import { Link } from "gatsby"
import { URLS } from "@data"
import { css, formatDate } from "@jsUtils"
import { ActionLink, CTA } from "@shared"

import Styles from "./contentgrid.module.scss"

/**
 * Render the left hand column aside
 * @param {object} props - react props
 * @param {string} category - category of article
 * @param {boolean} linkAuthor - if we should link the author or not
 * @param {boolean} linkBack - if we should link CTA link back?
 * @param {string} date - date of publication
 * @param {string} author - name of author
 * @param {string} exraClass - extra css class
 * @param {string} file - potential file download reference
 * @param {string} linkTo - add a link to this
 * @todo: make category, date, author, and file an array or something
 * @todo: actually, make those {children}
 */
const ContentAside = ({
  category,
  tags,
  linkBack,
  linkAuthor,
  date,
  author,
  file,
  extraClass,
  linkTo,
  targetAnchor,
  source
}) => {
  if (linkTo && linkBack) {
    const strLink = targetAnchor ? `${linkTo}#${targetAnchor}` : linkTo
    return (
      <aside className={css(Styles.articleAside, extraClass)}>
        <CTA ready to={strLink} flipped>
          Back
        </CTA>
      </aside>
    )
  }

  // determine Category list
  let categoryList = [category]

  if (tags) {
    categoryList.push(...tags)
  }

  categoryList = categoryList.filter((cat, index) => categoryList.indexOf(cat) === index)

  // determine Category heading
  const categoryHeading = categoryList.length > 1 ? "Categories" : "Category"

  return (
    <aside className={Styles.articleAside}>
      <dl className={extraClass}>
        {/* these should be something you can iterate over */}
        {category && (
          <>
            <dt>{categoryHeading}</dt>
            <dd>{categoryList.join(", ")}</dd>
          </>
        )}
        {date && (
          <>
            <dt>Date</dt>
            <dd>{formatDate(date)}</dd>
          </>
        )}
        {source && (
          <>
            <dt>Source</dt>
            <dd>{source}</dd>
          </>
        )}
        {author && (
          <>
            <dt>Author</dt>
            {linkAuthor && (
              <dd>
                <Link to={`${URLS.LEADERSHIP}${author.slug}`}>{author.name}</Link>
              </dd>
            )}
            {!linkAuthor && <dd>{author.name}</dd>}
          </>
        )}
        {file && (
          <>
            <dt>PDF File</dt>
            <dd className={Styles.filedown}>
              <ActionLink download text="Download" linkTarget={file} />
            </dd>
          </>
        )}
      </dl>
    </aside>
  )
}

export default ContentAside
